import script from "./SurveyBatchKestrel.vue?vue&type=script&setup=true&lang=js"
export * from "./SurveyBatchKestrel.vue?vue&type=script&setup=true&lang=js"

import "./SurveyBatchKestrel.vue?vue&type=style&index=0&id=35b3255c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-35b3255c"]])

export default __exports__